<template>
  <div class="pt1x  pr1x pl1x pb1x mMeduce"
       fillHeight="lastHeight"
       scroll>
    <div v-show="paramCategoryList.length==0"
         fillHeight="lastHeight">
      <NoResult></NoResult>
    </div>

    <div v-show="paramCategoryList.length > 0">
      <div class="panel bgContent mc mb1x borderbox"
           v-for="(item,i) in paramCategoryList"
           v-if="item.fieldList.length>0"
           :key="i">
        <section class="title title-bg curP"
                 @click="item.show=!item.show">
          <span>{{item.name}}</span>
          <span :class="[item.show?'fa-angle-down':'fa-angle-left']"
                class="dpIB fs16x fR fa tra-fast"></span>
        </section>
        <div class="cb"
             v-if="item.tag != 'electric'"
             v-show="item.show">
          <ul class="pt05x pb05x pl1x pr1x vaT_E">
            <li class="w33pct dpIB pt1x pb1x"
                v-for="(filed,ii) in item.fieldList"
                :key="i+ii"><span class="cSub">{{filed.key}}：</span>{{filed.value||'--'}} {{filed.unit}}</li>
          </ul>
        </div>
        <div class="cb"
             v-if="item.tag == 'electric'"
             v-show="item.show">
          <div class="head tableSys cField mt1x pt1x pb1x tra-fast_E dpIB_E" v-show='type!=="FAN"'>
            <div class="pb1x fMain vaM taC">
              <div>
                <div class="dpIB w5x cSub"
                     :title="getLanguageStr('word1177','直流')">{{getLanguageStr('word1177','直流')}}</div>
                <div class="dpIB w20pct cSub"
                     :title="getLanguageStr('word241','电压')">{{getLanguageStr('word241','电压')}}</div>
                <div class="dpIB w20pct cSub"
                     :title="getLanguageStr('word244','电流')">{{getLanguageStr('word244','电流')}}</div>
                <div class="dpIB w20pct cSub"
                     :title="getLanguageStr('plant367','功率')">{{getLanguageStr('plant367','功率')}}</div>
              </div>
              <div class="mt2x ng-scope"
                   v-if="item"
                   v-for="(item,index) in electricPVList">
                <div class="dpIB w5x cMain">PV{{index}}</div>
                <div class="dpIB w20pct cMain">{{item.DV||'--'}}</div>
                <div class="dpIB w20pct cMain">{{item.DC||'--'}}</div>
                <div class="dpIB w20pct cMain">{{item.DP||'--'}}</div>
              </div>
            </div>
            <div class="progressbar fMain pt2x pb1x vaM taC">
              <div class="h5x w35pct vaM dpIB">
                <div class="left bgProgress mb2x">
                  <div class="left leftFill bgMain progressLeftMove"></div>
                </div>
              </div>
              <div class="dpIB">
                <svg class="w5x h5x mc dpB">
                  <use xlink:href="#dv-inverter"></use>
                  <text x=".9em"
                        y="3.7em"
                        fill="white">DC/AC</text>
                </svg>
              </div>
              <div class="h5x w35pct vaM dpIB">
                <div class="right bgProgress mb2x">
                  <div class="right rightFill bgMain progressRightMove"></div>
                </div>
              </div>
            </div>
            <div class="pb1x fMain vaM taC">
              <div class="dpIB w5x cSub"
                   :title="getLanguageStr(stage.setting.loc.AC_name.title,'交流')">{{getLanguageStr(stage.setting.loc.AC_name.title,'交流')}}</div>
              <div class="dpIB w5x cSub"
                   :title="getLanguageStr('word241','电压')">{{getLanguageStr('word241','电压')}}</div>
              <div class="dpIB w5x cSub"
                   :title="getLanguageStr('word244','电流')">{{getLanguageStr('word244','电流')}}</div>
              <div class="dpIB w5x cSub"
                   :title="getLanguageStr('word860','频率')">{{getLanguageStr('word860','频率')}}</div>
              <div class="mt2x ng-scope"
                   v-if="item"
                   v-for="(item,index) in electricRSTList">
                <div class="dpIB w5x cMain ">
                  <span v-if="index == 1">{{getLanguageStr(stage.setting.loc.AC_name.list[index-1],'R')}}</span>
                  <span v-if="index == 2">{{getLanguageStr(stage.setting.loc.AC_name.list[index-1],'S')}}</span>
                  <span v-if="index == 3">{{getLanguageStr(stage.setting.loc.AC_name.list[index-1],'T')}}</span>
                </div>
                <div class="dpIB w5x cMain ">{{item.AV||'--'}}</div>
                <div class="dpIB w5x cMain ">{{item.AC||'--'}}</div>
                <div class="dpIB w5x cMain ">{{item.AF||'--'}}</div>
              </div>
            </div>
          </div>
          <ul class="pt05x pb05x pl1x pr1x vaT_E">
            <li class="w33pct dpIB pt1x pb1x"
                v-for="(filed,ii) in electricOtherList"
                :key="i+ii"><span class="cSub">{{filed.key}}：</span>{{(filed.value===false||filed.value===''||filed.value===null)?'--':filed.value}} {{filed.unit}}</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="panel bgContent mc mb1x borderbox"
         v-show='type!=="COLLECTOR"&&type!=="DTU"&&type!=="REPEATER"&&paramCategoryList.length > 0'>
      <section class="clearfix dateSys titleBar title-bg">
        <span class="fs14x">{{getLanguageStr('word1708','历史数据')}}</span>
        <div class="fR dateSys dpIB_E vaM_E">
          <div class="cField tra-fast_E posR"
               @mouseleave="leave">
            <!-- v-if="ActiveIndex<2" -->
            <button @mouseenter="paramChooiceShow"
                    :title="getLanguageStr('word566','参数选择')"
                    class="bdSub pl1x pr1x sizeS hover-main boxR-light"
                    ref="paramSele">{{getLanguageStr('word566','参数选择')}}</button>
            <DeviceDetailParam ref="DeviceDetailParam"
            @GetParam='GetParam'
                               :productId="productId"
                               @selectArray="updateShowParamArray"
                               :rightSide="rightSide"></DeviceDetailParam>
          </div>
          <div class="cField tra-fast_E vaM_E hover-cMain_E">
            <button id="prev"
                    class="w2x fa fa-angle-left fs14x"
                    type="button"
                    :class="{disable:timeChoose[ActiveIndex].type ==='all'}"
                    @click="dateChange('perv')"></button>
            <vue-datepicker-local v-model="rangeDate"
                                  format="YYYY"
                                  v-if="timeChoose[ActiveIndex].type ==='all'"
                                  disabled
                                  :local="local"
                                  class="datepicker "></vue-datepicker-local>
            <vue-datepicker-local v-model="time"
                                  @click.native="statistic('A68','A6805')"
                                  :format="timeChoose[ActiveIndex].format"
                                  ref="date"
                                  v-else-if="timeChoose[ActiveIndex].type ==='day'"
                                  :local="local"
                                  class="datepicker "
                                  @input="_showChartParam()"></vue-datepicker-local>
            <vue-datepicker-local v-model="week"
                                  type="week"
                                  @click.native="statistic('A68','A6840')"
                                  :format="timeChoose[ActiveIndex].format"
                                  ref="week"
                                  v-show="timeChoose[ActiveIndex].type ==='week'"
                                  :local="local"
                                  class="datepicker-week"
                                  @input="_showChartParam()"></vue-datepicker-local>
            <vue-datepicker-local v-model="month"
                                  type="month"
                                  @click.native="statistic('A68','A6811')"
                                  :format="timeChoose[ActiveIndex].format"
                                  ref="month"
                                  v-show="timeChoose[ActiveIndex].type ==='month'"
                                  :local="local"
                                  class="datepicker-month"
                                  @input="_showChartParam()"></vue-datepicker-local>
            <vue-datepicker-local v-model="year"
                                  type="year"
                                  @click.native="statistic('A68','A6817')"
                                  :format="timeChoose[ActiveIndex].format"
                                  ref="year"
                                  v-show="timeChoose[ActiveIndex].type ==='year'"
                                  :local="local"
                                  class="datepicker-year"
                                  @input="_showChartParam()"></vue-datepicker-local>
            <vue-datepicker-local v-model="total"
                                  disabled
                                  @click.native="statistic('A68','A6822')"
                                  type="total"
                                  :format="timeChoose[ActiveIndex].format"
                                  ref="total"
                                  v-show="timeChoose[ActiveIndex].type ==='total'"
                                  :local="local"
                                  class="datepicker-total"
                                  @input="_showChartParam()"></vue-datepicker-local>
            <button id="next"
                    class="w2x fa fa-angle-right fs14x"
                    type="button"
                    :class="{disable:timeChoose[ActiveIndex].type ==='all'}"
                    @click="dateChange('next')"></button>
          </div>
          <button type='button'
          v-if='!stage.setting.loc.shieldBlackList.report&&showDownload'
                  @click='download'
                  class='bdSub pl1x pr1x sizeS hover-main boxR-light mr1x'>{{getLanguageStr('report1','导出报表')}}</button>
          <div class="classGroup cb cField_E bdSub_E tra-fast_E">
            <button type="button"
                    :class="{active:ActiveIndex==index}"
                    v-for="(item,index) in timeChoose"
                    @click="_timePicker(item,index)"
                    :key="index">{{item.datepicker}}</button>
          </div>
        </div>
      </section>
      <div class="cb pr1x pl1x">
        <div class="pb1x">
          <ChartLine id="chartLine"
                     :data="ChartData"
                     :option="defChartMonthOption"
                     :chartClass="'w100pct h28x'"
                     v-if="ActiveIndex<2"></ChartLine>
          <ChartColumn id="chartColumn"
                       :data="ChartData"
                       :option="defChartMonthOption"
                       :chartClass="'w100pct h28x'"
                       v-else></ChartColumn>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
// 数据原样显示 单位需要换算 不换算的保留0
import {mapGetters, mapMutations, mapActions} from 'vuex';

import * as lib from '@/util/lib.js';
import {getLocal} from '@/util';
import {getLanguageStr} from '@/util/language.js';
import NoResult from '@/components/common/ui/NoResult.vue';
import Loading from '@/components/common/ui/Loading';
import ChartLine from '@/components/common/chart/ChartLine.vue';
import ChartColumn from '@/components/common/chart/ChartColumn.vue';
import TagForm from '@/components/common/ui/TagForm.vue';
import DeviceDetailParam from '@/view/device/device/part/DeviceDetailParam.vue';// 详情
import {apiReportDownLoad, apiDeviceParam} from '@/api/application/report';
import {deviceStatsDay, deviceStatsDayRange, apiDeviceStatsMonth, apiDeviceStatsYear, apiDeviceStatsTotal, deviceStatsYear, deviceStatsTotal, deviceParams} from '@/api/device/list';

export default {
	components: {Loading, TagForm, ChartLine, ChartColumn, DeviceDetailParam, NoResult},
	data () {
		return {
			stage,
			id: 'Detail' + Math.round(Math.random() * 99999),
			deviceDetail: null,
			paramCategoryList: [],
			deviceId: null,
			siteId: null,
			productId: null,
			timeZone: 'UTC',
			type: '',
			electricPVList: [],
			totalData: [],
			electricRSTList: [],
			electricOtherList: [],
			electricList: [],
			ActiveIndex: 0,
			local: {},
			isChart: true, // 图表数据是否加载完成
			time: new Date(),
			rangeDate: [new Date('2000'), new Date()],
			week: new Date(),
			month: lib.timeFormat(new Date(), 'inc', '%Y-%m'),
			year: lib.timeFormat(new Date(), 'inc', '%Y'),
			total: ['2002', '2024'],
			weekregion: [],
			monthData: [],
			yearData: [],
			timeChoose: [{
				datepicker: getLanguageStr('cmd93', '日'),
				format: 'YYYY/MM/DD',
				type: 'day'
			}, {
				datepicker: getLanguageStr('cmd94', '周'),
				format: 'YYYY/MM/DD',
				type: 'week'
			}, {
				datepicker: getLanguageStr('cmd95', '月'),
				format: 'YYYY/MM',
				type: 'month'
			}, {
				datepicker: getLanguageStr('cmd96', '年'),
				format: 'YYYY',
				type: 'year'
			}, {
				datepicker: getLanguageStr('cmd97', '总'),
				format: 'YYYY',
				type: 'total'
			}
				//			,{
				//				datepicker:getLanguageStr("cmd95","月"),
				//				format:'YYYY/MM',
				//				type:'month'
				//			},{
				//				datepicker:getLanguageStr("cmd96","年"),
				//				format:'YYYY',
				//				type:'year'
				//			},{
				//				datepicker:getLanguageStr("cmd97","总"),
				//				format:'YYYY',
				//				type:'all'
				//          }
			],
			showDownload: false,
			defChartMonthOption: {},
			ChartData: null, // 图标数据,
			showChartData: true,
			canclick: true,
			defaultParamArray: ['DV1', 'AV1'],
			showParamArray: ['DV1', 'AV1'], // 选择的参数模板,默认显示DV1、AV1
			detailData: {},
			chartList: {},
			rightSide: null,
			list: {
				active: [], // 当前选择
				data: {// 原始数据
					STATION: {

						multiple: [
							{
								name: getLanguageStr('plant_detail33', '电站名称'),
								storageName: 'NAME',
								readCode: 'name',
								unit: undefined,
								must: true
							},
							{
								name: getLanguageStr('word848', '地址'),
								storageName: 'LOCATION',
								readCode: 'location',
								unit: undefined
							},
							{
								name: getLanguageStr('word728', '电站类型'),
								storageName: 'STATION_TYPE',
								readCode: 'stationType',
								unit: undefined
							},
							{
								name: getLanguageStr('word736', '并网类型'),
								storageName: 'GRID_INTER_TYPE',
								readCode: 'gridInterType',
								unit: undefined
							},
							{
								name: getLanguageStr('word727', '装机容量') + '(kWp)',
								storageName: 'INSTALLED_CAPACITY',
								readCode: 'installedCapacity',
								unit: ''
							},
							{
								name: getLanguageStr('word1704', '业主姓名'),
								storageName: 'OWNER_NAME',
								readCode: 'ownerName',
								unit: undefined
							},
							{
								name: getLanguageStr('word1617', '业主联系电话'),
								storageName: 'CONTACT_PHONE',
								readCode: 'contactPhone',
								unit: undefined
							},
							{
								name: getLanguageStr('word1705', '业主工作单位'),
								storageName: 'OWNER_COMPANY',
								readCode: 'ownerCompany',
								unit: undefined
							}
						],
						single: {
							DISTRIBUTED_FULLY: [// 分布式全额上网
								{
									name: getLanguageStr('plant_detail33', '电站名称'),
									storageName: 'NAME',
									readCode: 'name',
									unit: undefined,
									must: true
								},

								{
									name: getLanguageStr('word727', '装机容量') + '(kWp)',
									storageName: 'INSTALLED_CAPACITY',
									readCode: 'installedCapacity',
									unit: ''
								}
							],
							EXCESS: [// 分布式自发自用余电上网
								{
									name: getLanguageStr('plant_detail33', '电站名称'),
									storageName: 'NAME',
									readCode: 'name',
									unit: undefined,
									must: true
								},
								{
									name: getLanguageStr('word848', '地址'),
									storageName: 'LOCATION',
									readCode: 'location',
									unit: undefined
								},
								{
									name: getLanguageStr('word728', '电站类型'),
									storageName: 'STATION_TYPE',
									readCode: 'stationType',
									unit: undefined
								},
								{
									name: getLanguageStr('word736', '并网类型'),
									storageName: 'GRID_INTER_TYPE',
									readCode: 'gridInterType',
									unit: undefined
								},
								{
									name: getLanguageStr('word727', '装机容量') + '(kWp)',
									storageName: 'INSTALLED_CAPACITY',
									readCode: 'installedCapacity',
									unit: ''
								},
								{
									name: getLanguageStr('word1704', '业主姓名'),
									storageName: 'OWNER_NAME',
									readCode: 'ownerName',
									unit: undefined
								},
								{
									name: getLanguageStr('word1617', '业主联系电话'),
									storageName: 'CONTACT_PHONE',
									readCode: 'contactPhone',
									unit: undefined
								},
								{
									name: getLanguageStr('word1705', '业主工作单位'),
									storageName: 'OWNER_COMPANY',
									readCode: 'ownerCompany',
									unit: undefined
								}
							],
							BATTERY_BACKUP: [// 储能系统
								{
									name: getLanguageStr('plant_detail33', '电站名称'),
									storageName: 'NAME',
									readCode: 'name',
									unit: undefined,
									must: true
								},
								{
									name: getLanguageStr('word848', '地址'),
									storageName: 'LOCATION',
									readCode: 'location',
									unit: undefined
								},
								{
									name: getLanguageStr('word728', '电站类型'),
									storageName: 'STATION_TYPE',
									readCode: 'stationType',
									unit: undefined
								},
								{
									name: getLanguageStr('word736', '并网类型'),
									storageName: 'GRID_INTER_TYPE',
									readCode: 'gridInterType',
									unit: undefined
								},
								{
									name: getLanguageStr('word727', '装机容量') + '(kWp)',
									storageName: 'INSTALLED_CAPACITY',
									readCode: 'installedCapacity',
									unit: ''
								},
								{
									name: getLanguageStr('word1704', '业主姓名'),
									storageName: 'OWNER_NAME',
									readCode: 'ownerName',
									unit: undefined
								},
								{
									name: getLanguageStr('word1617', '业主联系电话'),
									storageName: 'CONTACT_PHONE',
									readCode: 'contactPhone',
									unit: undefined
								},
								{
									name: getLanguageStr('word1705', '业主工作单位'),
									storageName: 'OWNER_COMPANY',
									readCode: 'ownerCompany',
									unit: undefined
								}
							]
						}
					},
					INVERTER: {
						multiple: [],
						single: [
							{
								name: getLanguageStr('word195', '设备类型'),
								storageName: 'TYPE_NAME',
								unit: undefined,
								must: true
							},
							{
								name: getLanguageStr('plant167', 'SN号'),
								storageName: 'DEVICE_SN',
								unit: undefined,
								must: true
							},
							{
								name: getLanguageStr('word1785', '所属系统'),
								storageName: 'OWN_STATION',
								unit: undefined
							},
							{
								name: getLanguageStr('word1522', '所属父设备'),
								storageName: 'PARENT_SN',
								unit: undefined
							}
						]
					},
					METER: {
						multiple: [],
						single: [
							{
								name: getLanguageStr('word195', '设备类型'),
								storageName: 'TYPE_NAME',
								unit: undefined,
								must: true
							},
							{
								name: getLanguageStr('plant167', 'SN号'),
								storageName: 'DEVICE_SN',
								unit: undefined,
								must: true
							},
							{
								name: getLanguageStr('word1785', '所属系统'),
								storageName: 'OWN_STATION',
								unit: undefined
							},
							{
								name: getLanguageStr('word1522', '所属父设备'),
								storageName: 'PARENT_SN',
								unit: undefined
							}
						]
					}

				}
			},
			yearExportValueFormat: false
		};
	},
	watch: {
		// ChartData: {
		//   // handler: function (nv, ov) {
		//   //   console.log(nv)
		//   //   // let data = nv.map(item => {
		//   //   //   if (item.unit === '℃') {
		//   //   //     // this.tempChange(this.preference.tempUnit, item.)
		//   //   //     item.detailList = item.detailList.map(its => {
		//   //   //       return this.tempChange(this.preference.tempUnit, its)
		//   //   //     })
		//   //   //     item.data = item.data.map(its => {
		//   //   //       its[1] = this.tempChange(this.preference.tempUnit, its[1])
		//   //   //       return its
		//   //   //     })
		//   //   //   }
		//   //   // })
		//   //   console.log(nv)
		//   //   return data
		//   // },
		//   // deep: true
		// }
	},
	created () {
		this._getLocal();
	},
	computed: {
		...mapGetters({
			preference: 'user/preference'
		})
	},
	methods: {
		getLanguageStr,
		statistic,
		floatFix: lib.floatFix,
		tempChange: lib.tempChange,
		convertData: lib.convertData,
		GetParam (data) {
			if (data && data.length > 0) {
				this.showDownload = true;
			} else {
				this.showDownload = false;
			}
		},
		getParams (timeDimension) {
			return new Promise((resolve, reject) => {
				apiDeviceParam({timeDimension: timeDimension, productId: this.productId, language: stage.languageId}).then(data => {
					resolve(data);
				}).catch(err => {
					!_.isEmpty(err) && this.$notify(err);
				});
			});
		},
		async download () {
			let request = {};
			request.displayParams = this.$refs.DeviceDetailParam.listData;
			// request.displayParams = this.detailData.filter(item => {
			//   if (item.selected) return item
			// })
			// console.log(request.displayParams)
			// console.log(this.detailData)
			request.deviceId = this.deviceId;
			request.deviceSn = this.deviceDetail.deviceSn;
			request.isPage = false;
			request.language = stage.languageId;
			request.parentSn = this.deviceDetail.parDeviceSn;
			request.parentTypeName = this.deviceDetail.parDeviceType;
			request.siteId = (!this.siteId || this.siteId !== -1) ? null : this.siteId;
			request.timeZone = this.deviceDetail.timeZone;
			request.typeNames = this.deviceDetail.type;
			request.typeName = lib.getTypeText(this.deviceDetail.type, 'deviceType');
			if (this.ActiveIndex == 0) { // 日
				request.timeDimension = 1; // 1：分钟，2：日，3：月
				// console.log(this.time)
				request.endDay = lib.timeFormat(this.time, 'system', '%Y-%m-%d');
				request.startDay = lib.timeFormat(this.time, 'system', '%Y-%m-%d');
				let param = await this.getParams(request.timeDimension);
				request.displayParams = param;
			} else if (this.ActiveIndex == 1) { // 周
				request.timeDimension = 1;
				request.endDay = lib.timeFormat(this.weekregion[1], 'system', '%Y-%m-%d');
				request.startDay = lib.timeFormat(this.weekregion[0], 'system', '%Y-%m-%d');
				let param = await this.getParams(request.timeDimension);
				request.displayParams = param;
			} else if (this.ActiveIndex == 2) { // 月
				// request.displayParams = this.getParamObject()
				request.timeDimension = 2;
				let nT = new Date(this.month);
				nT.setDate(1);
				let eT = new Date(nT);
				eT.setMonth(eT.getMonth() + 1);
				eT.setDate(eT.getDate() - 1);
				request.startDay = lib.timeFormat(nT, 'system', '%Y-%m-%d');
				request.endDay = lib.timeFormat(eT, 'system', '%Y-%m-%d');
			} else if (this.ActiveIndex == 3) { // 年
				// request.displayParams = this.getParamObject()
				request.timeDimension = 3;
				let year = '';
				if (this.yearExportValueFormat) {
					year = this.year.getFullYear();
				} else {
					year = this.year;
				}
				console.log(year, 'year');
				request.startMonth = year + '-1';
				request.endMonth = year + '-12';
			} else {
				let year = new Date().getFullYear();
				// request.displayParams = this.getParamObject()
				request.timeDimension = 4;
				request.startYear = year - 20;
				request.endYear = year;
			}
			request.filterNulls = true;
			request.reportFields = this.list.data.INVERTER.single;
			request.qtyType = 'single';
			request.orderDirection = 'ASC';
			request.orderProperty = 'collectTime';
			request.productId = this.productId;
			// request.timeDimension = '' // 1：分钟，2：日，3：月
			apiReportDownLoad(request).then(res => {
				let blob = new Blob([res], {type: 'application/ms-excel'});
				let downloadElement = document.createElement('a');
				let href = window.URL.createObjectURL(blob); // 创建下载的链接
				downloadElement.href = href;
				let title = '';
				let format = request.timeDimension == 3 ? '%Y-%m' : '%Y-%m-%d';
				let issingleName = request.qtyType === 'single' ? getLanguageStr('word1860', '单个') : getLanguageStr('word1864', '多个');
				// console.log(this.range,this.requestData)
				let showname = this.deviceDetail.deviceSn;

				let isStationName = (request.typeNames != 'STATION' ? lib.getTypeText(request.typeNames, 'deviceType') + request.deviceSn : showname + request.typeNames);
				if (this.ActiveIndex == 0 || this.ActiveIndex == 1 || this.ActiveIndex == 2) {
					title = lib.timeFormat(request.startDay, 'system', '%Y-%m-%d') + '~' + lib.timeFormat(request.endDay, 'system', '%Y-%m-%d') + isStationName + getLanguageStr('word1290', '报表');
				} else if (this.ActiveIndex == 3) {
					title = lib.timeFormat(request.startMonth, 'system', '%Y-%m') + '~' + lib.timeFormat(request.endMonth, 'system', '%Y-%m') + isStationName + getLanguageStr('word1290', '报表');
				} else if (this.ActiveIndex == 4) {
					title = request.startYear + '~' + request.endYear + isStationName + getLanguageStr('word1290', '报表');
				} else {
					title = lib.timeFormat(request.startYear, 'system', '%Y') + '~' + lib.timeFormat(request.endYear, 'system', '%Y') + isStationName + getLanguageStr('word1290', '报表');
				}
				downloadElement.download = `${title}.xlsx`; // 下载后文件名
				document.body.appendChild(downloadElement);
				downloadElement.click(); // 点击下载
				document.body.removeChild(downloadElement); // 下载完成移除元素
				window.URL.revokeObjectURL(href); // 释放掉blob对象
			}, error => {
				// console.log(error)
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		toDecimal (x) {
			var f = parseFloat(x);
			if (isNaN(f)) {
				return false;
			}
			var f = Math.round(x * 100) / 100;
			var s = f.toString();
			var rs = s.indexOf('.');
			if (rs < 0) {
				rs = s.length;
				s += '.';
			}
			while (s.length <= rs + 2) {
				s += '0';
			}
			return s;
		},
		_getLocal () {
			this.local = getLocal();
		},
		setIndex () {
			// console.log(11111)
			this.ActiveIndex = 0;
			// this._timePicker(0, 0)
		},
		paramChooiceShow () {
			if (this.ActiveIndex == 0) { // 日
				statistic('A68', 'A6802');
			} else if (this.ActiveIndex == 1) {
				statistic('A68', 'A6837');
			} else if (this.ActiveIndex == 2) {
				statistic('A68', 'A6808');
			} else if (this.ActiveIndex == 3) {
				statistic('A68', 'A6814');
			} else {
				statistic('A68', 'A6819');
			}
			this.rightSide = document.body.clientWidth - $(this.$refs.paramSele).offset().left;
			this.$nextTick(() => {
				this.$refs.DeviceDetailParam.show(this.showParamArray, this.defaultParamArray);
			});
		},
		updateShowParamArray (selectArray) {
			this.detailData = this.detailData.map(item => {
				if (selectArray.includes(item.storageName)) item.selected = true; else item.selected = false;
				return item;
			});
			this.showParamArray = selectArray;

			if (this.ActiveIndex == 0) { // 日
				statistic('A68', 'A6806', 'select_device_day_parameters', this.showParamArray);
				this.paramChatShow();
			} else if (this.ActiveIndex == 1) {
				statistic('A68', 'A6838', 'select_device_week_parameters', this.showParamArray);
				this.weekChatShow();
			} else if (this.ActiveIndex == 2) {
				statistic('A68', 'A6809', 'select_device_month_parameters', this.showParamArray);
				this.monthShow();
			} else if (this.ActiveIndex == 3) {
				statistic('A68', 'A6815', 'select_device_year_parameters', this.showParamArray);
				this.yearShow();
			} else {
				statistic('A68', 'A6821', 'select_device_total_parameters', this.showParamArray);
				this.titalShow();
			}
		},
		getCurWeek (d) {
			this.weekregion = [];
			let presentDate = d,
				weekday = presentDate.getDay() || 7;
			let fd = presentDate.setDate(presentDate.getDate() - weekday + 1);
			this.weekregion.push(new Date(fd));// 本周第一天
			this.weekregion.push(new Date((fd / 1000 + 6 * 86400) * 1000));// 本周最后一天
		},
		show (device) {
			statistic('A68', 'A6801');
			var date = new Date();
			date.setHours(0);
			date.setMilliseconds(0);
			date.setSeconds(0);
			date.setMinutes(0);
			this.time = new Date(date.getTime());
			if (this.type !== 'COLLECTOR') { this.$refs.DeviceDetailParam.initShowParam(false); }
			this.getCurWeek(new Date());
			let deviceDetail = _.cloneDeep(device);
			this.deviceDetail = _.cloneDeep(device);
			this.time = new Date(lib.timeFormat(deviceDetail.collectionTime ? deviceDetail.collectionTime : new Date(), 'utc', '%Y/%m/%d', {offset: deviceDetail.timeZone}));
			this.week = new Date(lib.timeFormat(deviceDetail.collectionTime ? deviceDetail.collectionTime : new Date(), 'utc', '%Y/%m/%d', {offset: deviceDetail.timeZone}));
			this.deviceId = deviceDetail.deviceId;
			this.siteId = deviceDetail.siteId;
			this.productId = deviceDetail.productId;
			this.timeZone = deviceDetail.timeZone;
			this.type = this.deviceDetail.type;
			var _this = this;
			if (this.type !== 'COLLECTOR') {
				this.$refs.DeviceDetailParam.getDefaultParamList(this.productId, deviceDetail.type).then(function (res) {
					_this.defaultParamArray = res;
				});
			}
			// DV1和APo1；
			this.electricPVList = [];
			this.electricRSTList = [];
			this.electricOtherList = [];
			this.electricList = [];
			let preUnit = ['w', 'W', 'kWh', 'wh', 'Wh', 'kW'];
			let preUnitKw = ['kw', 'kW'];
			let preUnitKwh = ['kWh'];

			this.paramCategoryList = deviceDetail.paramCategoryList.map(item => {
				item.show = true;// 默认显示
				if (item.tag == 'electric') this.electricList = item.fieldList;
				// if (item.tag == 'alert') { item.fieldList = item.fieldList.filter(alert => !alert.storageName.startsWith('ERR')) }

				item.fieldList = item.fieldList.map(itm => { // 特殊单位 进位处理
					if (preUnit.includes(itm.unit)) {
						let con;
						if (preUnitKw.includes(itm.unit)) {
							con = this.convertData(itm.value, null, 'k', 'w', false);
							itm.value = itm.value >= 1000 ? con[1] : itm.value;
							itm.unit = con[2];
						} else if (preUnitKwh.includes(itm.unit)) {
							if (Number(itm.value)) {
								con = this.convertData(itm.value, null, 'k', 'Wh', false);
								itm.value = itm.value >= 1000 ? con[1] : itm.value;
								itm.unit = con[2];
							}
						} else {
							con = this.convertData(itm.value, null, '', itm.unit, false);
							itm.value = con[1];
							itm.unit = con[2];
						}
					} else if (!itm.unit) {
						itm.value = itm.value;
					} else if (itm.unit === '℃') {
						itm.value = this.tempChange(this.preference.tempUnit, itm.value)[1];
						itm.unit = this.tempChange(this.preference.tempUnit, itm.value)[2];
					} else if (itm.unit) {
						itm.value = itm.value;
					}
					return itm;
				});
				return item;
			});
			this.electricList = this.electricList.map(item => {
				let t = item.storageName.substr(0, 2);// 类型
				let idx = item.storageName.substr(2);// 下标
				if (item.unit) {
					item.value = item.value;
				}
				if (!item.storageName.includes('_')) {
					switch (t) { // D:直流 A：交流 P：功率 C：电流 V：电压 F：频率
					case 'DC':
						if (this.electricPVList[idx]) this.electricPVList[idx].DC = preUnit.includes(item.unit) ? this.convertData(item.value, null, '', item.unit, false)[0] : item.value + item.unit;
						else this.electricPVList[idx] = {'DC': preUnit.includes(item.unit) ? this.convertData(item.value, null, '', item.unit, false)[0] : item.value + item.unit};
						this.electricPVList[idx].dcV = item.value;// 记录dc dv value处理pv
						break;
					case 'DV': // 交流频率
						if (this.electricPVList[idx]) this.electricPVList[idx].DV = preUnit.includes(item.unit) ? this.convertData(item.value, null, '', item.unit, false)[0] : item.value + item.unit;
						else this.electricPVList[idx] = {'DV': preUnit.includes(item.unit) ? this.convertData(item.value, null, '', item.unit, false)[0] : item.value + item.unit};
						this.electricPVList[idx].dvV = item.value;
						break;
					case 'DP': // 交流功率 功率单位统一处理
						if (this.electricPVList[idx]) this.electricPVList[idx].DP = item.value + ' ' + item.unit;
						else this.electricPVList[idx] = {'DP': item.value + ' ' + item.unit};
						break;
					case 'AC': // 交流频率
						if (this.electricRSTList[idx]) this.electricRSTList[idx].AC = preUnit.includes(item.unit) ? this.convertData(item.value, null, '', item.unit, false)[0] : item.value + item.unit;
						else this.electricRSTList[idx] = {'AC': preUnit.includes(item.unit) ? this.convertData(item.value, null, '', item.unit, false)[0] : item.value + item.unit};
						break;
					case 'AV': // 交流电源
						if (this.electricRSTList[idx]) this.electricRSTList[idx].AV = preUnit.includes(item.unit) ? this.convertData(item.value, null, '', item.unit, false)[0] : item.value + item.unit;
						else this.electricRSTList[idx] = {'AV': preUnit.includes(item.unit) ? this.convertData(item.value, null, '', item.unit, false)[0] : item.value + item.unit};
						break;
					case 'AF': // 交流频率
						if (this.electricRSTList[idx]) this.electricRSTList[idx].AF = preUnit.includes(item.unit) ? this.convertData(item.value, null, '', item.unit, false)[0] : item.value + item.unit;
						else this.electricRSTList[idx] = {'AP': preUnit.includes(item.unit) ? this.convertData(item.value, null, '', item.unit, false)[0] : item.value + item.unit};
						break;
					default:
						this.electricOtherList.push(item);
						break;
					};
				} else if (item.storageName.includes('A_Fo')) {
					idx = item.storageName.substr(4);
					if (this.electricRSTList[idx]) this.electricRSTList[idx].AF = item.value + ' ' + item.unit;
					else this.electricRSTList[idx] = {'AF': item.value + ' ' + item.unit};
				} else {
					if (item.value === false || item.value === '' || item.value === null) {
						item.value = '--';
					}
					this.electricOtherList.push(item);
				}
				return item;
			});

			this.electricPVList.map(item => {
				if (!item.PV) item.PV = this.convertData(item.dcV * item.dvV, null, '', 'w', false)[0];
			});
			if (this.type !== 'COLLECTOR') {
				setTimeout(() => {
					this._showChart();// 表格数据
				}, 0);
			}
		},
		// 日历
		dateChange (str) {
			if (str === 'perv') {
				if (this.ActiveIndex == 0) { // 日
					statistic('A68', 'A6804');
				} else if (this.ActiveIndex == 1) {
					statistic('A68', 'A6839');
				} else if (this.ActiveIndex == 2) {
					statistic('A68', 'A6810');
				} else if (this.ActiveIndex == 3) {
					statistic('A68', 'A6816');
				}
			} else {
				if (this.ActiveIndex == 0) { // 日
					statistic('A68', 'A6806');
				} else if (this.ActiveIndex == 1) {
					statistic('A68', 'A6841');
				} else if (this.ActiveIndex == 2) {
					statistic('A68', 'A6812');
				} else if (this.ActiveIndex == 3) {
					statistic('A68', 'A6818');
				}
			}
			// type day(日) week(周) month(月) year(年) all(总)
			let type = this.timeChoose[this.ActiveIndex].type;
			let val;
			if (type == 'week') {
				val = this.$refs.week.text;
			} else if (type == 'month') {
				val = this.$refs.month.text + '/01';
			} else if (type == 'day') {
				val = this.$refs.date.text;
			} else if (type == 'year') {
				val = this.$refs.year.text;
			} else if (type == 'total') {
				val = this.$refs.total.text;
			}
			var date;
			// console.log(val)
			// var date=new Date(val);
			if (type === 'month') {
				let vr = val.split('/');
				date = new Date(vr[0], vr[1] - 1);
			} else {
				date = new Date(type !== 'week' && type !== 'total' ? val : val.split('~').pop());
			}

			// console.log(date)
			switch (type) {
			case 'day':
				var step = str === 'next' ? 1 : -1;
				date.setDate(date.getDate() + step);
				this.$refs.date.selectOk(date);
				break;
			case 'week':
				var step = str === 'next' ? 7 : -7;
				date.setDate(date.getDate() + step);
				this.$refs.week.selectOk(date);
				break;
			case 'month':
				var step = str === 'next' ? 1 : -1;
				date.setMonth(date.getMonth() + step);
				this.$refs.month.selectOk(date);
				break;
			case 'quarter':
				var step = str === 'next' ? 3 : -3;
				this.curQuarter = Math.ceil((date.getMonth() + 1 + step) / 3);
				date.setMonth(date.getMonth() + step);
				this.$refs.date.selectOk(date);
				break;
			case 'year':
				var step = str === 'next' ? 1 : -1;
				date.setFullYear(date.getFullYear() + step);
				this.$refs.year.selectOk(date);
				break;
			default:
				break;
			}
		},
		// 获取天数
		_getCountDays () {
			let curDate = _.cloneDeep(this.time);
			// let curMonth =curDate.getMonth()
			// curDate.setMonth(curMonth+1)
			// curDate.setDate(0);
			// return curDate.getDate()
			let curMonth = curDate.getMonth() + 1;
			let curYear = curDate.getFullYear();
			return new Date(curYear, curMonth, 0).getDate();
		},
		_showChart () {
			this.detailData = {};
			this.isChart = true;
			this.chartList = {};
			this.ChartData = null;
			for (let attr in this.proportion) {
				this.proportion[attr] = 0;
			}
			let _this = this;
			// 日曲线图
			if (this.ActiveIndex == 0) { // 日
				let _this = this;
				this.$refs.DeviceDetailParam.getDefaultParamList(this.productId, this.type, 1, this.ActiveIndex).then(function (res) {
					_this.defaultParamArray = res;
					_this.showParamArray = _this.defaultParamArray;
					_this._chartDay();
				});
			} else if (this.ActiveIndex == 1) { // 周
				let _this = this;
				this.$refs.DeviceDetailParam.getDefaultParamList(this.productId, this.type, 1, this.ActiveIndex).then(function (res) {
					_this.defaultParamArray = res;
					_this.showParamArray = _this.defaultParamArray;
					_this._chartWeek();
				});
			} else if (this.ActiveIndex == 2) { // 月图标
				// this.showParamArray = ['generation']
				// let dateNum = this._getCountDays()
				// this.chartList = {
				//   generation: {
				//     name: getLanguageStr('word597', '当月发电量（有功）'),
				//     unit: 'kWh',
				//     data: new Array(dateNum)
				//   },
				//   discharge: {
				//     name: getLanguageStr('word1354', '放电量'),
				//     unit: 'kWh',
				//     data: new Array(dateNum)
				//   }
				// }
				this.ChartData = [];
				let _this = this;
				this.$refs.DeviceDetailParam.getDefaultParamList(this.productId, this.type, 2, this.ActiveIndex).then(function (res) {
					_this.defaultParamArray = res;
					_this.showParamArray = _this.defaultParamArray;
					_this._chartMonth();
				});
			} else if (this.ActiveIndex == 3) { // 年
				// this.showParamArray = ['generation']
				this.ChartData = [];
				let _this = this;
				this.$refs.DeviceDetailParam.getDefaultParamList(this.productId, this.type, 2, this.ActiveIndex).then(function (res) {
					_this.defaultParamArray = res;
					_this.showParamArray = _this.defaultParamArray;
					_this._chartYear();
				});
			} else if (this.ActiveIndex == 4) { // 总
				this.ChartData = [];
				let _this = this;
				this.$refs.DeviceDetailParam.getDefaultParamList(this.productId, this.type, 2, this.ActiveIndex).then(function (res) {
					_this.defaultParamArray = res;
					_this.showParamArray = _this.defaultParamArray;
					_this._chartTotal();
				});
			}
		},
		_showChartParam () {
			if (this.ActiveIndex == 0) { // 日
				this._chartDay();
			} else if (this.ActiveIndex == 1) { // 周图表
				this._chartWeek();
			} else if (this.ActiveIndex == 2) { // 月
				this._chartMonth();
			} else if (this.ActiveIndex == 3) { // 年
				this.yearExportValueFormat = true;
				this._chartYear();
			} else {
				this._chartTotal();
			}
		},
		leave () {
			this.paramChooiceActive = false;
			this.$refs.DeviceDetailParam.showParam = false;
		},
		paramChatShow () {
			this.ChartData = [];
			if (this.detailData.length > 0) {
				this.chartList = {};
				let yt = [];
				this.detailData.map((item, i) => {
					if (this.showParamArray.includes(item.storageName)) {
						this.chartList[i] = {...item};
						this.chartList[i].data = [];
						item.detailList.map(dl => {
							let ct = Number(dl.collectionTime) * 1000 + stage.time.timezoneMap[this.timeZone].offset * 1000;
							this.chartList[i].data.push([ct, Number(dl.value)]);// 重组data
						});
						this.chartList[i].data = lib.sortData(this.chartList[i].data, {byKey: 0});
						this.ChartData.push(this.chartList[i]); // 重组chartData

						if (!yt.includes(item.unit)) yt.push(item.unit);// 添加y轴
					};
				});

				this.ChartData = this.ChartData.map(item => {
					let tempu = '';
					if (item.unit === '℃') {
						// this.tempChange(this.preference.tempUnit, item.)
						item.detailList = item.detailList.map(its => {
							tempu = this.tempChange(this.preference.tempUnit, its)[2];
							return this.tempChange(this.preference.tempUnit, its)[1];
						});
						item.data = item.data.map(its => {
							its[1] = this.tempChange(this.preference.tempUnit, its[1])[1];
							return its;
						});
					} else {
						tempu = item.unit;
					}
					item.unit = tempu;
					return item;
				});
				this.defChartMonthOption = (function () { // 默认月图表参数
					let obj = { // d
						yTitle: yt,
						opposite: true

					};
					return obj;
				}());
			}
		},
		weekChatShow () {
			this.ChartData = [];
			if (this.detailData.length > 0) {
				this.chartList = {};
				let yt = [];
				this.detailData.map((item, i) => {
					if (this.showParamArray.includes(item.storageName)) {
						this.chartList[i] = {...item};
						this.chartList[i].data = [];
						item.detailList.map(dl => {
							let ct = Number(dl.collectionTime) * 1000 + stage.time.timezoneMap[this.timeZone].offset * 1000;
							this.chartList[i].data.push([ct, Number(dl.value)]);// 重组data
						});
						this.chartList[i].data = lib.sortData(this.chartList[i].data, {byKey: 0});
						this.ChartData.push(this.chartList[i]); // 重组chartData

						if (!yt.includes(item.unit)) yt.push(item.unit);// 添加y轴
					};
				});
				this.ChartData = this.ChartData.map(item => {
					let tempu = '';
					if (item.unit === '℃') {
						// this.tempChange(this.preference.tempUnit, item.)
						item.detailList = item.detailList.map(its => {
							tempu = this.tempChange(this.preference.tempUnit, its)[2];
							return this.tempChange(this.preference.tempUnit, its)[1];
						});
						item.data = item.data.map(its => {
							its[1] = this.tempChange(this.preference.tempUnit, its[1])[1];
							return its;
						});
					} else {
						tempu = item.unit;
					}
					item.unit = tempu;
					return item;
				});
				let startD = this.weekregion[0];
				this.defChartMonthOption = (function () { // 默认月图表参数
					let obj = { // d
						yTitle: yt,
						timeType: 'week',
						opposite: true,
						startDate: startD
					};
					return obj;
				}());
			}
		},
		// 日图表数据
		_chartDay () {
			lib.loadingChange($('#chartLine [Loading]'), true);
			// console.log(lib.timeFormat(this.time, 'inc', '%Y/%m/%d'), this.time)
			let chooseDay = {
				'day': lib.timeFormat(this.time, 'system', '%Y/%m/%d'),
				'lan': stage.languageId
			};
			deviceStatsDay(this.deviceId, chooseDay).then(response => {
				lib.loadingChange($('#chartLine [Loading]'), false);
				this.isChart = false;
				if (response) {
					this.detailData = response.map(item => {
						if (this.defaultParamArray.includes(item.storageName)) item.selected = true; else item.selected = false;
						return item;
					});
				} else {
					this.detailData = [];
				}
				this.paramChatShow();
			}, error => {
				lib.loadingChange($('#chartLine [Loading]'), false);
				this.isChart = false;
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		// 周图表数据
		_chartWeek () {
			lib.loadingChange($('#chartLine [Loading]'), true);

			this.getCurWeek(this.week);
			let chooseDay = {
				'startDay': lib.timeFormat(this.weekregion[0], 'system', '%Y/%m/%d'),
				'endDay': lib.timeFormat(this.weekregion[1], 'system', '%Y/%m/%d'),
				'lan': stage.languageId
			};
			deviceStatsDayRange(this.deviceId, chooseDay).then(response => {
				lib.loadingChange($('#chartLine [Loading]'), false);
				this.isChart = false;
				// this.showParamArray = this.defaultParamArray
				if (response) {
					this.detailData = response.map(item => {
						if (this.defaultParamArray.includes(item.storageName)) item.selected = true; else item.selected = false;
						return item;
					});
				} else {
					this.detailData = [];
				}
				this.weekChatShow();
			}, error => {
				lib.loadingChange($('#chartLine [Loading]'), false);
				this.isChart = false;
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		// 月图表数据
		_chartMonth () {
			lib.loadingChange($('#chartColumn [Loading]'), true);
			let chooseMonth = {
				'year': lib.timeFormat(this.month, 'system', '%Y'),
				'month': lib.timeFormat(this.month, 'system', '%m')
			};
			this.detailData = [];
			apiDeviceStatsMonth(this.deviceId, chooseMonth).then(response => {
				lib.loadingChange($('#chartColumn [Loading]'), false);
				this.isChart = false;
				// 判断现在选中了哪些
				// this.detailData = Object.keys(response.records).map(item => {
				//   let items = { storageName: item }
				//   if (this.defaultParamArray.includes(item)) items.selected = true; else items.selected = false
				//   return items
				// })
				// console.log(response)
				this.monthData = response.records;
				this.monthShow();
			}, error => {
				lib.loadingChange($('#chartColumn [Loading]'), false);
				this.isChart = false;
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		isInlcudeIn (objectPa, items) {
			let itemArr = objectPa.filter(item => {
				if (item === items.storageName) return item;
			});
			if (itemArr.length > 0) {
				return true;
			} else {
				return false;
			}
		},
		getParamObject () {
			return this.$refs.DeviceDetailParam.listData.filter(item => {
				if (this.isInlcudeIn(this.showParamArray, item)) {
					// console.log(item)
					return item;
				}
			});
		},
		monthShow () {
			// 组装数据开始
			// 没有返回的数据需要补齐
			// 选择器当天时间
			let dataNow = new Date().setMonth(Number((lib.timeFormat(this.month, 'system', '%m') - 1)));
			// 获取当月的最大值
			let dataNowF = new Date(dataNow).setDate(1);
			let dataNextF = new Date(dataNowF).setMonth(new Date(dataNowF).getMonth() + 1);
			let MaxMonth = new Date(new Date(dataNextF).setDate(new Date(dataNextF).getDate() - 1)).getDate();

			let xCategories = [];
			let paramArr = this.getParamObject() || [];

			let ChartDataArr = [];
			let dataInit = [];
			let title = [];
			for (let i = 0; i < MaxMonth; i++) {
				xCategories.push(i + 1);
				dataInit.push('');
			}
			// console.log(paramArr)
			if (paramArr.length > 0 && paramArr[0]) {
				paramArr.map(items => {
					let data = {name: '', data: dataInit.slice()};
					data.name = items.name;
					data.unit = items.unit;
					if (!title.includes(items.unit)) {
						title.push(items.unit);
					}
					this.monthData.map(item => {
						let n = Number(item.day.substr(item.day.length - 2, item.day.length));
						if (item[items.storageName]) {
							data.data.splice(n - 1, 1, Number(item[items.storageName]));
						} else {
							data.data.splice(n - 1, 1, 0);
						}
					});
					ChartDataArr.push(data);
				});
				let chartshow = false;
				ChartDataArr.map(item => {
					item.data.map(items => {
						if (items && item !== null) chartshow = true;
					});
				});
				if (!chartshow) ChartDataArr = [];
			} else {
				paramArr = [];
			}

			this.defChartMonthOption = (function () { // 默认月图表参数
				let obj = { // d
					yTitle: title,
					timeType: 'month',
					opposite: true
				};
				$.each(obj.xCategories, function (index) {
					obj.xCategories[index] = index + 1;
				});
				return obj;
			}());
			// console.log(ChartDataArr)
			this.defChartMonthOption.xCategories = xCategories;

			this.ChartData = ChartDataArr;
			this.ChartData = this.ChartData.map(item => {
				let tempu = '';
				if (item.unit === '℃') {
					// this.tempChange(this.preference.tempUnit, item.)
					item.detailList = item.detailList.map(its => {
						tempu = this.tempChange(this.preference.tempUnit, its)[2];
						return this.tempChange(this.preference.tempUnit, its)[1];
					});
					item.data = item.data.map(its => {
						its[1] = this.tempChange(this.preference.tempUnit, its[1])[1];
						return its;
					});
				} else {
					tempu = item.unit;
				}
				item.unit = tempu;
				return item;
			});
		},
		_chartYear () {
			lib.loadingChange($('#chartColumn [Loading]'), true);
			let chooseYear = {
				'year': lib.timeFormat(new Date(this.year), 'system', '%Y')
			};
			this.detailData = [];
			apiDeviceStatsYear(this.deviceId, chooseYear).then(response => {
				lib.loadingChange($('#chartColumn [Loading]'), false);
				this.isChart = false;
				// 判断现在选中了哪些
				// this.detailData = Object.keys(response.records).map(item => {
				//   let items = { storageName: item }
				//   if (this.defaultParamArray.includes(item)) items.selected = true; else items.selected = false
				//   return items
				// })
				// console.log(response)
				this.yearData = response.records;
				this.yearShow();
			}, error => {
				lib.loadingChange($('#chartColumn [Loading]'), false);
				this.isChart = false;
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		yearShow () {
			// 组装数据开始
			// 没有返回的数据需要补齐
			let xCategories = [];
			let paramArr = this.getParamObject() || [];
			// console.log(paramArr)
			let ChartDataArr = [];
			let dataInit = [];
			let title = [];
			for (let i = 0; i < 12; i++) { // new Array(12)
				xCategories.push(i + 1);
				dataInit.push('');
			}
			// console.log(paramArr)
			if (paramArr.length > 0 && paramArr[0]) {
				paramArr.map(items => {
					let data = {name: '', data: dataInit.slice()};
					data.name = items.name;
					data.unit = items.unit;
					if (!title.includes(items.unit)) {
						title.push(items.unit);
					}
					this.yearData.map(item => {
						let n = Number(item.month);
						if (item[items.storageName]) {
							data.data.splice(n - 1, 1, Number(item[items.storageName]));
						} else {
							data.data.splice(n - 1, 1, 0);
						}
					});
					ChartDataArr.push(data);
				});

				let chartshow = false;
				ChartDataArr.map(item => {
					item.data.map(items => {
						if (items && item !== null) chartshow = true;
					});
				});
				if (!chartshow) ChartDataArr = [];
			} else {
				paramArr = [];
			}

			this.defChartMonthOption = (function () { // 默认月图表参数
				let obj = { // d
					yTitle: title,
					timeType: 'year',
					opposite: true
				};
				$.each(obj.xCategories, function (index) {
					obj.xCategories[index] = index + 1;
				});
				return obj;
			}());

			this.defChartMonthOption.xCategories = xCategories;

			this.ChartData = ChartDataArr;
			this.ChartData = this.ChartData.map(item => {
				let tempu = '';
				if (item.unit === '℃') {
					// this.tempChange(this.preference.tempUnit, item.)
					item.detailList = item.detailList.map(its => {
						tempu = this.tempChange(this.preference.tempUnit, its)[2];
						return this.tempChange(this.preference.tempUnit, its)[1];
					});
					item.data = item.data.map(its => {
						its[1] = this.tempChange(this.preference.tempUnit, its[1])[1];
						return its;
					});
				} else {
					tempu = item.unit;
				}
				item.unit = tempu;
				return item;
			});
		},
		_chartTotal () {
			lib.loadingChange($('#chartColumn [Loading]'), true);
			this.detailData = [];
			apiDeviceStatsTotal(this.deviceId).then(response => {
				lib.loadingChange($('#chartColumn [Loading]'), false);
				this.isChart = false;
				// this.showParamArray = this.defaultParamArray
				// 判断现在选中了哪些
				// this.detailData = Object.keys(response.records).map(item => {
				//   let items = { storageName: item }
				//   if (this.defaultParamArray.includes(item)) items.selected = true; else items.selected = false
				//   return items
				// })
				// console.log(response)
				this.totalData = response.records;
				this.titalShow();
			}, error => {
				lib.loadingChange($('#chartColumn [Loading]'), false);
				this.isChart = false;
				!_.isEmpty(error) && this.$notify(error);
			});
		},
		titalShow () {
			// 组装数据开始
			// 没有返回的数据需要补齐
			let xCategories = [];
			let paramArr = this.getParamObject() || [];
			let ChartDataArr = [];
			let dataInit = [];
			let title = [];
			for (let i = this.total[0] - 1; i < this.total[1]; i++) { // new Array(12)
				xCategories.push(i + 1);
				dataInit.push('');
			}
			if (paramArr.length > 0 && paramArr[0]) {
				paramArr.map(items => {
					let data = {name: '', data: dataInit.slice()};
					data.name = items.name;
					data.unit = items.unit;
					if (!title.includes(items.unit)) {
						title.push(items.unit);
					}
					this.totalData.map(item => {
						let n = Number(item.year);
						if (item[items.storageName]) {
							data.data.splice(n - this.total[0], 1, Number(item[items.storageName]));
						} else {
							data.data.splice(n - this.total[0], 1, 0);
						}
						// data.data.splice(2013 - 2012, 1, 10)
					});
					ChartDataArr.push(data);
				});
				let chartshow = false;
				ChartDataArr.map(item => {
					item.data.map(items => {
						if (items && item !== null) chartshow = true;
					});
				});
				if (!chartshow) ChartDataArr = [];
			} else {
				paramArr = [];
			}

			this.defChartMonthOption = (function () { // 默认月图表参数
				let obj = { // d
					yTitle: title,
					timeType: 'all',
					opposite: true
				};
				$.each(obj.xCategories, function (index) {
					obj.xCategories[index] = index + 1;
				});
				return obj;
			}());
			this.defChartMonthOption.xCategories = xCategories;

			this.ChartData = ChartDataArr;
			this.ChartData = this.ChartData.map(item => {
				let tempu = '';
				if (item.unit === '℃') {
					// this.tempChange(this.preference.tempUnit, item.)
					item.detailList = item.detailList.map(its => {
						tempu = this.tempChange(this.preference.tempUnit, its)[2];
						return this.tempChange(this.preference.tempUnit, its)[1];
					});
					item.data = item.data.map(its => {
						its[1] = this.tempChange(this.preference.tempUnit, its[1])[1];
						return its;
					});
				} else {
					tempu = item.unit;
				}
				item.unit = tempu;
				return item;
			});
		},
		// 总图表数据
		_totalData () {
			lib.loadingChange($('#chartColumn [Loading]'), true);
			// equipmentApi.cancelRequest()
			deviceStatsTotal(this.siteId, this.deviceId).then(response => {
				lib.loadingChange($('#chartColumn [Loading]'), false);
				this.isChart = false;
				if (!response) return;
				this.detailData = response;
				this.chartList = {};
				if (this.detailData.length == 0) {
					this.ChartData = [];
				} else {
					let startYear = [];
					for (let attr in response) {
						startYear.push(response[attr].collectionYear + '');
					}
					startYear = lib.sortData(startYear)[0]; // 获取最小的年份
					let endYear = lib.timeFormat(new Date(), 'system', '%Y'); // 获取当年年份
					let YearNum = this.total[1] - this.total[0] + 1; // X轴总数
					this.rangeDate = this.total;
					this.chartList = {
						generation: {
							name: getLanguageStr('word597', '当月发电量（有功）'),
							unit: 'kWh',
							data: new Array(YearNum)
						},
						discharge: {
							name: getLanguageStr('word1354', '放电量'),
							unit: 'kWh',
							data: new Array(YearNum)
						}
					};
					for (let attr in this.chartList) {
						$.each(this.chartList[attr].data, (index) => {
							this.chartList[attr].data[index] = null;
						});
						this.detailData.map((val, index) => {
							this.chartList[attr].data[parseInt(val.collectionYear) - Number(startYear)] = Number(val[attr]);
						});
						this.ChartData.push(this.chartList[attr]);
					}
					this.ChartData = this.ChartData.map(item => {
						let tempu = '';
						if (item.unit === '℃') {
							// this.tempChange(this.preference.tempUnit, item.)
							item.detailList = item.detailList.map(its => {
								tempu = this.tempChange(this.preference.tempUnit, its)[2];
								return this.tempChange(this.preference.tempUnit, its)[1];
							});
							item.data = item.data.map(its => {
								its[1] = this.tempChange(this.preference.tempUnit, its[1])[1];
								return its;
							});
						} else {
							tempu = item.unit;
						}
						item.unit = tempu;
						return item;
					});
					this.defChartMonthOption = (function () { // 默认月图表参数
						let obj = { // d
							yTitle: ['kWh', 'kWh'],
							timeType: 'all',
							opposite: true,
							xCategories: new Array(YearNum)
						};
						$.each(obj.xCategories, function (index) {
							obj.xCategories[index] = index + Number(startYear);
						});
						return obj;
					}());
				}
			}, error => {
				lib.loadingChange($('#chartColumn [Loading]'), false);
				!_.isEmpty(error) && this.$notify(error);
				this.isChart = false;
			});
		},
		_timePicker (item, index) {
			// this.CHANGE(index)

			if (this.canclick) {
				this.ActiveIndex = index;
				if (this.ActiveIndex == 0) { // 日
					// statistic('A68', 'A6804')
				} else if (this.ActiveIndex == 1) {
					// statistic('A68','A6839', )
				} else if (this.ActiveIndex == 2) {
					statistic('A68', 'A6807');
				} else if (this.ActiveIndex == 3) {
					statistic('A68', 'A6813');
				} else {
					statistic('A68', 'A6819-');
				}
				this._showChart();
				this.canclick = false;
			}
			setTimeout(_ => {
				this.canclick = true;
			}, 500);
		}
	},
	mounted () {
		lib.fillHeight();
		lib.setScroll($(this.$el));
		let Year = new Date().getFullYear();
		this.total = [(Year - 19).toString(), Year.toString()];
		// console.log(this.total)
	}
};
</script>
<style lang="scss" scoped>
.panel .title {
  margin-bottom: 0;
}

.datepicker {
  width: 125px !important;
  height: 2.2em;
  line-height: 2.2em;
}

.datepicker-week {
  width: 200px !important;
  height: 2.2em;
  line-height: 2.2em;
}

.progressbar {
  .left {
    height: 10px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    margin-right: -5px;
  }
  .right {
    height: 10px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    margin-left: -5px;
  }
  .leftFill {
    margin-right: 0;
    width: 0;
  }
  .rightFill {
    margin-left: 0;
    width: 0;
  }
  .progressLeftMove {
    animation: leftmove 5s;
    -webkit-animation: leftmove 5s infinite;
    -moz-animation: leftmove 5s infinite;
    animation-iteration-count: infinite;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    animation-fill-mode: forwards;
    -webkit-animation-fill-mode: forwards;
    -moz-animation-fill-mode: forwards;
  }
  .progressRightMove {
    animation: rightmove 5s;
    -webkit-animation: rightmove 5s infinite;
    -moz-animation: rightmove 5s infinite;
    animation-iteration-count: infinite;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    animation-fill-mode: forwards;
    -webkit-animation-fill-mode: forwards;
    -moz-animation-fill-mode: forwards;
  }
  @keyframes leftmove {
    0% {
      width: 0px;
    }
    50% {
      width: 100%;
    }
    100% {
      width: 100%;
    }
  }
  @-webkit-keyframes leftmove {
    0% {
      width: 0px;
    }
    50% {
      width: 100%;
    }
    100% {
      width: 100%;
    }
  }
  @keyframes rightmove {
    0% {
      width: 0px;
    }
    50% {
      width: 0px;
    }
    100% {
      width: 100%;
    }
  }
  @-webkit-keyframes rightmove {
    0% {
      width: 0px;
    }
    50% {
      width: 0px;
    }
    100% {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/device/device/part/Detail.vue